module.exports = __webpack_public_path__ + "img/tullips.31706f1e.png";